export enum userPermissions {
    'Administration' = 'Administration',

    'view-idms-menu' = 'iDMS',
    //org
    'organization' = 'Administration/Organisation',
    'view-organization' = 'Administration/Organisation',
    'add-organization' = 'Administration/Organisation',
    'edit-organization/:id' = 'Administration/Organisation',

    //mgmt/org
    //'view-organization' = "Administration/Organisation",

    //instance
    'view-instance' = 'Administration/Organisation/Instance',
    'add-instance' = 'Administration/Organisation/Instance',
    'edit-instance/:id' = 'Administration/Organisation/Instance',

    //org-users
    'org-user' = 'Administration/Organisation/User',

    //org-SecurityRoles
    'org-SecurityRole' = 'Administration/Organisation/Security Role',

    //Informate Configuration
    'InformateConfiguration' = 'Administration/Organisation/Instance/Informate Configuration',

    //Instance-user
    'Instance-user' = 'Administration/Organisation/Instance/User',

    // informate
    'view-informate' = 'Informate',
    'view-informate-settings' = 'Informate/Settings',

    // Idms
    'view-idms-settings' = 'iDMS/Settings',

    // standard flange
    'standardflange/:isRedirect' = 'Informate/StandardFlange',

    // custom flange
    'customflange/:isRedirect' = 'Informate/CustomFlange',

    // clamp
    'clamp/:isRedirect' = 'Informate/Clamp',

    // EngineeredJoint
    'engineeredjoint/:isRedirect' = 'Informate/EngineeredJoint',

    // override-flange
    'view-overriddenflange' = 'Informate/OverriddenFlange',

    //Matrix
    'view-matrix' = 'Informate/Matrix',
    'matrix' = 'Informate/Matrix',

    // settings routes
    'heroImages' = 'General Settings/Hero Images',
    'news' = 'General Settings/News',
    'Pricing' = 'General Settings/Pricing Details',
    'profile' = 'User Profile',
    'idms' = 'iDMS/Settings',
    'informate' = 'Informate/Settings',
    'general' = 'General Settings',
    'view-profile-setting' = 'User Profile',
    'profile-personal-setting' = 'User Profile/Personal',
    'profile-email-notification-setting' = 'User Profile/Emails & Notifications',
    'view-activity-pack-type' = 'Administration/Organisation/Instance/Activity Pack Type',
    'view-project-type' = 'Administration/Organisation/Instance/Project Type',
    'view-hierarchy' = 'Administration/Organisation/Instance/View',
    'view-modify' = 'Administration/Organisation/Instance/View',
    'view-instance-configuration' = 'Administration/Organisation/Instance/Informate Configuration',
    'view-instace-user' = 'Administration/Organisation/Instance/User',
    'viewLineNumberFormat' = 'Administration/Organisation/Instance/Line Number Format',

    //In settings Informate settings
    'settings-defaults' = 'Informate/Settings/Defaults',
    'settings-calculation-preferences' = 'Informate/Settings/Calculation Preferences',

    //idms settings
    'settings-iDMS-pipeCodes' = 'iDMS/Settings/Pipe Codes',
    'settings-iDMS-dataUploads' = 'iDMS/Settings/Uploads',
    'settings-iDMS-approvals' = 'iDMS/Settings/Approvals',
    'settings-iDMS-rules' = 'iDMS/Settings/Rules',
    // IDMS Settings
    'createDbLookUpField' = 'Administration/Organisation/Instance/DB Lookup Field',
    'deleteDbLookUpField' = 'Administration/Organisation/Instance/DB Lookup Field',
    'modifyDbLookUpFiled' = 'Administration/Organisation/Instance/DB Lookup Field',
    'viewDbLookUpField' = 'Administration/Organisation/Instance/DB Lookup Field',

    'createMaterialAlias' = 'iDMS/Settings/Material Alias',
    'deleteMaterialAlias' = 'iDMS/Settings/Material Alias',
    'modifyMaterialAlias' = 'iDMS/Settings/Material Alias',
    'viewMaterialAlias' = 'iDMS/Settings/Material Alias',
    'plantmanager' = 'iDMS/Tagged Item',
    'plantmanager/:isRedirect' = 'iDMS/Tagged Item',
    // 'plantmanager/:activetab' = 'iDMS/Tagged Item',
    'plantmanager/:activetab/:taggeditemid' = 'iDMS/Tagged Item',
    'idms/project-manager' = 'iDMS/Project',
    'project-manager' = 'iDMS/Project',
    'workpack' = 'iDMS/Project/WorkPack',
    'activityWorkpack' = 'iDMS/Project/WorkPack/Activity',
    'reports' = 'Reports',
    'dashboard' = 'iDMS/Dashboard',
    'settings-iDMS-barcode' = 'iDMS/Settings/Barcode & QR Code',

    'search' = 'iDMS/Site Search',
    'Reports-Scheduling' = 'Reports/Scheduling',

    //CDMS
    'view-ca' = 'CA',
    'competencymodule' = 'CA/Competency',
    'cdms-Dashboard' = 'CA/Dashboard',
    'cdms-Enrollments' = 'CA/Enrollments',
    'cdms-Personnel' = 'CA/Personnel',
    'personnel' = 'CA/Personnel',
    'cdms-settings' = 'CA/Settings',
    'cdms-settings-lookups' = 'CA/Settings/Lookups',
    'cdms-settings-grade-matrix' = 'CA/Settings/Grade Matrix',
    'cdms-settings-certificates' = 'CA/Settings/Certificates',
}

export enum userActions {
    'View' = 'View',
    'Create' = 'Create',
    'Edit' = 'Modify',
    'Delete' = 'Delete',
}
